
(function($) {
    /*$(window).scroll(function() {
       var hT = $('.summary-block').offset().top,
           hH = $('.summary-block').outerHeight(),
           wH = $(window).height(),
           wS = $(this).scrollTop();

           if (wS > (hT+hH-wH) && (hT > wS) && (wS+wH > hT+hH)){
                $('.summary-block').addClass('is-fixed');
            }
            else {
                $('.summary-block').removeClass('is-fixed');
            }
    });*/
//set recap selection as sticky

    $(function () {
        let $watermarkCasa = $(".bg-watermark--casa-animated");
        let $frameTypeText = $watermarkCasa.parents(".frame-type-text");
        let windowWidth = $(window).width();

        if ($watermarkCasa.length && $frameTypeText.length) {
            if( windowWidth > 1023 ) {

                let is_sticky = false;
                let position_fixed = $watermarkCasa.offset().top;
                let container_height = $("main#main-content").height();
                let full_height = container_height;
                let resume_height = $watermarkCasa.outerHeight();
                let frame_height = $frameTypeText.outerHeight();

                $(document).scroll(function () {

                    if (window.scrollY + resume_height - full_height > 0) {
                        $watermarkCasa.removeClass("is-fixed");
                        $watermarkCasa.addClass("position-fixed-footer");
                        $frameTypeText.css("position", "static");
                        // $(".entry-content").css("position", "relative");
                        is_sticky = false;
                    }
                    if (!is_sticky && position_fixed <= window.scrollY && window.scrollY + resume_height - full_height < 0) {
                        $watermarkCasa.addClass("position-fixed");
                        $watermarkCasa.removeClass("position-fixed-footer");
                        $frameTypeText.css("position", "relative");
                        $frameTypeText.css("height", frame_height + "px");
                        //$(".entry-content").css("position", "static");
                        is_sticky = true;
                    } else if (is_sticky && position_fixed > window.scrollY) {
                        $watermarkCasa.removeClass("position-fixed");
                        is_sticky = false;
                    }
                });
            }
        }
    });

})(jQuery);
